<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="breadcrumb-area pos-relative w-100">
          <h1>{{ dataRequest.id ? 'Sửa' : 'Thêm mới' }} danh mục ticket</h1>
          <div style="float: right">
            <button type="button" @click="$router.push('/ticket-category')" class="btn btn-light">
              Hủy bỏ
            </button>
            <button class="btn btn-success btn-primary ml-2">
              {{ dataRequest.id ? 'Lưu' : 'Thêm mới' }}
            </button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="productId" name="Dịch vụ">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Dịch vụ<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2
                      :disabled="!!dataRequest.id"
                      v-model="dataRequest.productId"
                      :options="dataProduct"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="groupId" name="Mã nhóm ticket">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Mã nhóm ticket<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2
                      :disabled="!!dataRequest.id"
                      v-model="dataRequest.groupId"
                      :options="listsGroupTicket"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|codeGroupTicket"
                vid="code"
                name="Mã danh mục ticket"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Mã danh mục ticket<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-9">
                    <input
                      :disabled="!!dataRequest.id"
                      type="text"
                      class="form-control"
                      v-model.trim="dataRequest.code"
                      @input="toUpperCase()"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|minMaxName_7"
                vid="name"
                name="Tên danh mục ticket"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Tên danh mục ticket<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model.trim="dataRequest.name" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="minMaxName_6" vid="description" name="Mô tả">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">Mô tả</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="dataRequest.description" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="isHandmade" name="Cập nhật thủ công">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Cập nhật thủ công<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2
                      @select="checkShowWorkflow(dataRequest.isHandmade)"
                      v-model="dataRequest.isHandmade"
                      :options="dataUpdateHandmade"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-if="checkWorkflow"
                rules="required"
                vid="processWorkflowId"
                name="Mã workflow"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Mã workflow<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2 v-model="dataRequest.processWorkflowId" :options="listsCodeWorkflow" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="numberCheck_1" vid="duration" name="Hạn xử lý">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">Hạn xử lý (ngày)</label>
                  <div class="col-sm-9">
                    <input type="number" class="form-control" v-model="dataRequest.duration" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>

<script>
  import { TicketService } from '@/services/ticket.service'
  import Config from '@/thirdParty/config'
  import mxItemAction from '../mx-item-action.js'
  export default {
    name: 'ticket-category-request',
    data() {
      return {
        Config,
        dataRequest: {},
        dataProduct: [],
        showLoading: false,
        listsGroupTicket: [],
        dataUpdateHandmade: Config.updateHandmadeCategoryTicket,
        checkWorkflow: false,
        listsCodeWorkflow: [],
      }
    },
    mixins: [mxItemAction],
    mounted() {
      this.fetchDataProduct()
      this.fetchDataGroupTicket()
      this.fetchData()
      this.fetchDataWorkflow()
    },
    methods: {
      async fetchDataProduct() {
        try {
          this.showLoading = true
          const response = await TicketService.fetchProduct()
          if (response.code === 1000) {
            response.data.map(e => {
              const arr = { id: e.id, text: e.name }
              this.dataProduct.push(arr)
            })
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async submitRequest() {
        try {
          this.showLoading = true
          const params = {
            code: this.dataRequest.code,
            description: this.dataRequest.description,
            duration: this.dataRequest.duration,
            groupId: this.dataRequest.groupId,
            isHandmade: this.dataRequest.isHandmade,
            productId: this.dataRequest.productId,
            name: this.dataRequest.name,
            processWorkflowId:
              this.dataRequest.isHandmade === 'false' ? this.dataRequest.processWorkflowId : '',
          }
          if (this.dataRequest.id) {
            params.id = this.dataRequest.id
            const response = await TicketService.updateCategory(params)
            if (response.success) {
              this.showSuccessMx('Cập nhật danh mục ticket thành công').then(() =>
                this.$router.push('/ticket-category')
              )
            } else this.showFailMx(response.message)
          } else {
            const response = await TicketService.createCategory(params)
            if (response.success) {
              this.showSuccessMx('Thêm mới danh mục ticket thành công').then(() =>
                this.$router.push('/ticket-category')
              )
            } else this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchData() {
        const ticketId = this.$route.params.id
        if (ticketId) {
          try {
            this.showLoading = true
            const responsive = await TicketService.getDetailCategory({
              id: ticketId,
            })
            this.dataRequest = responsive.data
            this.dataRequest.productId = responsive.data.productRes.id
            this.dataRequest.groupId = responsive.data.groupRes.id
            this.dataRequest.isHandmade = String(responsive.data.isHandmade)
            this.checkShowWorkflow(String(responsive.data.isHandmade))
            this.dataRequest.processWorkflowId = responsive.data.processWorkflowId
          } catch (error) {
            console.log(error)
          } finally {
            this.showLoading = false
          }
        }
      },
      async fetchDataGroupTicket() {
        try {
          this.showLoading = true
          const response = await TicketService.fetchGroup()
          if (response.code === 1000) {
            response.data.map(e => {
              const arr = { id: e.id, text: e.code }
              this.listsGroupTicket.push(arr)
            })
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchDataWorkflow() {
        try {
          this.showLoading = true
          const response = await TicketService.getCodeWorkflow()
          if (response.code === 1000) {
            response.data.map(e => {
              const arr = { id: e.processWorkflowId, text: e.processWorkflowId }
              this.listsCodeWorkflow.push(arr)
            })
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      toUpperCase() {
        this.dataRequest.code = this.dataRequest.code.toUpperCase()
        this.dataRequest.code = this.dataRequest.code.replace(/[^\w\sÀ-ỹ]/g, '')
      },
      checkShowWorkflow(data) {
        if (data === 'true') {
          this.checkWorkflow = false
        } else this.checkWorkflow = true
      },
    },
  }
</script>

<style scoped></style>
